import React from "react";
import { useLocation } from "react-router-dom";
import BackBar from "./BackBar";

/* =========================================================
   Global back bar for account-style pages.

   Mount this ONCE in your router file (GoHubApp.js), directly
   ABOVE <Routes> (it must be inside the <BrowserRouter>):

     import AccountBackBar from "./goourhub/component/AccountBackBar";
     ...
     <AccountBackBar />
     <Routes> ... </Routes>

   It renders nothing on normal pages, and shows a sticky
   back bar (back button + title) on the paths listed below  
   no changes to ProfilePage.jsx needed. If your profile route
   isn't one of these paths, add it to SHOW_ON.
   ========================================================= */
const SHOW_ON = [
  { match: /^\/profile(\/|$)/i, title: "My GoOurHub" },
  { match: /^\/my-?goourhub(\/|$)/i, title: "My GoOurHub" },
  { match: /^\/my-?profile(\/|$)/i, title: "My GoOurHub" },
  { match: /^\/account(\/|$)/i, title: "My GoOurHub" },
  { match: /^\/me(\/|$)/i, title: "My GoOurHub" },
];

export default function AccountBackBar() {
  const { pathname } = useLocation();

  const entry = SHOW_ON.find((item) => item.match.test(pathname));

  if (!entry) {
    return null;
  }

  return <BackBar title={entry.title} />;
}
